<template>
    <NewsSection 
        :tabs="tabs"
        :articles="articles" />
</template>

<script>
import { mapActions } from 'vuex';
import NewsSection from '../../sections/NewsSection/NewsSection.vue';

export default {
    name: 'ArticleList',

    components: {
        NewsSection
    },

    data() {
        return {
            articles        : [],
            tabs            : [],
            isError         : false,    // есть ли ошибка
            animationOpacity: '1',      // анимация - время перехода
            animationDisplay: 'block',  // анимация - тип отображени
        };
    },


    async created() {
        this.getListData();
        this.startAnimationFade();
    },

    methods: {
        ...mapActions(['getNewsList']),

        /**
         * Получаем список новостей и акций
         */
        async getListData() {
            try {
                const response = await this.getNewsList();
                this.tabs = response.categories;
                this.articles = response.articles;

                if (!this.articles || !this.tabs) {
                    this.showError();
                }
            } catch (error) {
                this.showError();
                console.error(error);
            }
        },

        startAnimationFade() {
            this.animationDisplay = 'none';
            this.animationOpacity = '0';

            setTimeout(() => {
                this.animationDisplay = 'block';
            }, 50);

            setTimeout(() => {
                this.animationOpacity = '1';
            }, 300);
        },
    }
};
</script>